<template>
  <div>
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  <h4 class="title">Person Details</h4>
  <card>
  
  
  
   <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Person Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{model.first_name}} {{model.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{model.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
      <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Nationality</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{model.nationality}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
      <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{model.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
      <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Email</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{model.email}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
      <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{model.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
  
  </card>
  
  
  
  <div style="margin-top:50px">
    <h4 v-if="createForm"  class="card-title">
      Create A New Officer Entry
    </h4>
     <h4 v-else slot="header" class="card-title">
     Update Officer Entry
    </h4>
  </div>
 <card class="form-horizontal">
  
    


	 <div class="row">
      <label class="col-sm-2 col-form-label">Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="model.status">
                    <el-option v-for="option in selects.officer_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>



    <div class="row">
      <label class="col-sm-2 col-form-label">Is Officer Point-Of-Contact</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.is_contact_person">
                    <el-option v-for="option in selects.is_contact"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    
    <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.effective_date" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
	
	 <div class="row">
      <label class="col-sm-2 col-form-label">Position</label>
      <div class="col-sm-7">
              <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Position"
                             v-model="model.position">
                    <el-option v-for="option in selects.officer_position"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="title"

                  v-model="model.title">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>


   

  </card>
           <div slot="footer" class="text-center">
      <p-button v-if="createForm"  type="info" @click.prevent="validate">Submit New Officer</p-button>
      <p-button v-else  type="info" @click.prevent="editEntity">Edit Officer</p-button>
    </div>
   


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     
     
       if(this.$route.params.oid!=0){
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/officers/'+ this.$route.params.oid+"/entity/"
     		+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.officer;
			    
			
			})

     	}
     	
     	if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				//this.createForm = false
				//this.model = response.data.entity;
				this.coy = response.data.entity;
				
			
			})
      	}//get connected entity info
      	
      	
      
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	createForm: true,
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          effective_date: '',
          position:1,
          title:'',
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
          status: {
          	required: true,
          },
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
           position: {
            required: true,
          },
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
        },
        
        selects: {
          officer_status: [
            {value: 1, label: 'Active'},
            {value: 2, label: 'Resigned'},
		   ],
		  officer_position: [
            {value: 1, label: 'Director'},
            {value: 2, label: 'Nominee Director'},
            {value: 3, label: 'Secretary'},
            {value: 4, label: 'Director & Secretary'},
            {value: 5, label: 'Data Protection Officer'},
            {value: 6, label: 'Director & Data Protection Officer'},
		   ],
		  is_contact:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] 
        },
      }
    },
    methods:{
       createEntity: function () {
       
       },
        goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	    },
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/officers';
      		ApiService.post(uri, this.model).then(response => {
      	
         			this.$router.push( '/view-entity/'+this.eid)
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editEntity() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/officers/edit/'+this.oid+'/entity/'+this.eid;
      		ApiService.post(uri, this.model).then(response => {
      	
         			this.$router.push('/view-officer/'+this.$route.params.oid+'/entity/'+this.eid)
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


